const routes = {
  home: '/',
  company: '/company',
  document: '/doc/:id',
};

export default routes;
